import React, { useState } from "react";
import { toast } from "react-toastify";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";

import api from "../../../services/api";
import Backdrop from "../../Backdrop";
import { Container, FielButtons } from "./styles";

export default function DialogRecoverPassword(props) {
  const [open, setOpen] = React.useState(true);
  const [email, setEmail] = React.useState("");
  const [showbackdrop, setShowbackdrop] = useState(false);

  const handleClose = () => {
    setOpen(false);
    setTimeout(() => props.fechar(), 100);
  };

  const setNewPassword = (event) => {
    event.preventDefault();
    setShowbackdrop(true);

    api
      .post(`/users/password/recovery-email`, { email: email })
      .then(() => {
        setShowbackdrop(false);
        toast.success("E-mail para recuperar senha foi enviado com sucesso!");
        handleClose();
      })
      .catch((error) => {
        console.error(error);
        toast.warn(
          "Não foi possível enviar o email de recuperação de senha",
        );
        setShowbackdrop(false);
      });
  };

  return (
    <div>
      <Dialog
        open={open}
        maxWidth="md"
        scroll="body"
        fullScreen={window.innerWidth > 675 ? false : true}
        fullWidth
        style={{
          zIndex: 999991,
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent
          style={{
            padding: "2rem 1.575rem",
          }}
        >
          <DialogContentText id="alert-dialog-description">
            <Container>
              <header>
                <h1>Recuperação de Senha</h1>
                <span>
                  Digite seu email cadastrado para que se possa realizar a
                  recuperação.
                </span>
              </header>
              <form className="div__oneRow" onSubmit={setNewPassword}>
                <input
                  className="input-custom-style"
                  type="email"
                  placeholder="E-mail"
                  value={email}
                  autoFocus
                  onChange={(e) => setEmail(e.target.value.toLowerCase())}
                />
                <button className="primary-button-style" type="submit">
                  Enviar
                </button>
              </form>
            </Container>
          </DialogContentText>
        </DialogContent>
        <DialogActions
          style={{
            padding: "0 1.575rem 2rem",
          }}
        >
          <FielButtons>
            <button
              onClick={handleClose}
              className="secondary-button-style"
              color="primary"
              style={{
                minWidth: "100px",
              }}
            >
              Voltar
            </button>
          </FielButtons>
        </DialogActions>
      </Dialog>
      {showbackdrop && <Backdrop />}
    </div>
  );
}
